import {
    FETCH_LOGIN_REQUEST,
    FETCH_LOGIN_SUCCESS,
    FETCH_LOGIN_FAILED
} from "./type";

import axios from "axios";
import { API_ENDPOINT } from '../../AppConfig';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { showSnack } from 'react-redux-snackbar';

export function RegisterRequest(data, lang) {

    return (dispatch, getState) => {
        dispatch({ type: FETCH_LOGIN_REQUEST });
        dispatch(showLoading());
        let uri = `${API_ENDPOINT}/signup`;
        axios.post(uri, data, {
            headers: {
                'Accept-Language': lang
            }
        }).then(response => {
            saveToLocalStorage('JAZANtoken', JSON.stringify(response.data.token));
            saveToLocalStorage('JAZANuser', JSON.stringify(response.data.user));
            // saveToLocalStorage('JazanType', JSON.stringify(response.data.user.type));
            dispatch({ type: FETCH_LOGIN_SUCCESS, payload: response.data });
            dispatch(hideLoading());
        }).catch(error => {
            dispatch({ type: FETCH_LOGIN_FAILED });            
            if (!error.response) {
                dispatch(hideLoading());
                dispatch(showSnack('myUniqueId', {
                    label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                    timeout: 7000,
                    button: { label: lang === 'en' ? 'Register' : 'الاشتراك' }
                }));
            } else if (error.response.status === 422) {
                error.response.data.errors.map((item, index) => {
                    if (item.param === "email") {
                        dispatch(showSnack('myUniqueId', {
                            label: item.msg,
                            timeout: 7000,
                            button: { label: lang === 'en' ? 'Signup' : 'الاشتراك' }
                        }));
                    }
                    if (item.param === 'phone') {
                        dispatch(showSnack('myUniqueId', {
                            label: item.msg,
                            timeout: 7000,
                            button: { label: lang === 'en' ? 'Signup' : 'الاشتراك' }
                        }));
                    }
                    if (item.param === 'name') {
                        dispatch(showSnack('myUniqueId', {
                            label: item.msg,
                            timeout: 7000,
                            button: { label: lang === 'en' ? 'Signup' : 'الاشتراك' }
                        }));
                    }
                })
                dispatch(hideLoading());

            } else if (error.response.status === 401) {
                dispatch(hideLoading());
            }

        })
    }
}

export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}